import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface MenuSignature {
  Element: HTMLDivElement;
  Args: { title?: string };
  Blocks: { default: [] };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DialogTitle: typeof DialogTitle;
  }
}

const DialogTitle: TemplateOnlyComponent<MenuSignature> = <template>
  <div class='border-grey-200 border-b pb-5 pt-7 px-8'>
    <h2
      id='modal-heading'
      class='font-black leading-none mb-1 text-center text-xl'
      ...attributes
    >
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        {{@title}}
      {{/if}}
    </h2>
  </div>
</template>;

export default DialogTitle;
